import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  title: {
    fontWeight: 'bold',
  },
}))

export default styles
